import { useEffect, useState } from "react";
import './App.css';
import Navbar from './components/Navbar';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Shop from './pages/Shop';
import ShopCategory from './pages/ShopCategory';
import Product from './pages/Product';
import Cart from './pages/Cart';
import Msg from './pages/Msg';
import Login from './pages/Login';
import EmailVerify from './pages/EmailVerify';
import ResetPassword from './pages/ResetPassword';
import Footer from './components/Footer';

function Layout() {
  const location = useLocation();
  const pathName = location.pathname;
  const hideNavbar = pathName === "/email-verify" || pathName === "/reset-password" || pathName === "/msg";
  const hideFooter = pathName === "/email-verify" || pathName === "/login" || pathName === "/reset-password" || pathName === "/msg";

  return (
    <div>
      {!hideNavbar && <Navbar />}
      <Outlet />
      {!hideFooter && <Footer />}
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Shop /> },
      { path: ":category", element: <ShopCategory /> },
      { path: "product", element: <Product /> },
      { path: "product/:id", element: <Product /> },
      { path: "cart", element: <Cart /> },
      { path: "msg", element: <Msg /> },
      { path: "login", element: <Login /> },
      { path: "email-verify", element: <EmailVerify /> },
      { path: "reset-password", element: <ResetPassword /> },
    ],
  }
]);

function App() {
  const [toastPosition, setToastPosition] = useState("bottom-right");

  useEffect(() => {
    const updatePosition = () => {
      if (window.innerWidth < 768) {
        setToastPosition("top-right");
      } else {
        setToastPosition("bottom-right");
      }
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);

    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer
        position={toastPosition}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />
    </>
  )
}

export default App;